import React from "react";
import assign from "lodash.assign";
import PageText from "constants/v2/PageText";
import SubscriptionDetails from "../../v3/subscription-details/SubscriptionDetails";
import PaymentDetails from "../../v3/payment-details/PaymentDetails";
import { THINKING_TYPE_LOADING } from "common/constants/v2/Constants";
import REDUX_ERROR_TYPES from "constants/ReduxErrorTypes";
import BillingHistory from "../BillingHistory";
import isSubscriptionAdmin from "common/utils/isSubscriptionAdmin";
import { findCurrentSubscriptionWithDetails } from "common/utils/subscriptionHelpers";

const NoSubscriptions = ({ subscriptionOfferUrl }) => {
    return (
        <div className="subscriptions__accounts no-subscriptions">
            <div className="subscriptions__accounts-message">You have no active subscriptions.</div>
            <a className="subscriptions__accounts-see-offers" href={ subscriptionOfferUrl }>See My Subscription Offers</a>
        </div>
    );
};

const LoadingMessage = () => {
    return (
        <div className="subscriptions__accounts loading-subscriptions">
            <div className="subscriptions__accounts-message">Loading your subscriptions...</div>
        </div>
    );
};

class Subscriptions extends React.Component {
    constructor(props) {
        super(props);

        this.props.setThinking(THINKING_TYPE_LOADING);
        this._onStripeSubmit = this._onStripeSubmit.bind(this);
    }

    componentDidMount() {
        this.props.checkUser();
        this.props.getSubscriptionsData();
    }

    _onStripeSubmit(paymentData) {
        const {
            type,
            id
        } = this.props.subscriptions[0];
        const { token, card } = paymentData;

        this.props.onStripeSubmit(assign({}, paymentData, {
            paymentMethod: {
                creditCard: {
                    stripeToken: token,
                    tokenId: card.id
                }
            },
            type,
            id
        }));
    }

    _showSubscriptionDetails() {
        const {
            subscriptionOfferUrl,
            subscriptions,
            bloombergSiteUrl
        } = this.props;

        return subscriptions.length
            ? subscriptions.map((subscription, index) => {
                return (
                    <SubscriptionDetails
                        { ...subscription }
                        bloombergSiteUrl={ bloombergSiteUrl }
                        key={ index }
                    />
                );
            })
            : <NoSubscriptions subscriptionOfferUrl={ subscriptionOfferUrl } />;
    }

    _showPaymentInformation() {
        const {
            subscriptions,
            paymentForm,
            thinking,
            grecaptchaApiKey,
            submitPayment,
            editPayment,
            isEditingPayment
        } = this.props;

        const subscription = findCurrentSubscriptionWithDetails(subscriptions);

        if (!subscription || !isSubscriptionAdmin(subscription)) {
            return null;
        }

        const paymentMethod = subscription.paymentMethod;

        if (!paymentMethod) {
            return null;
        }

        return (
            <div className="subscriptions__payment-information">
                <PaymentDetails
                    editPayment={ editPayment }
                    isEditingPayment={ isEditingPayment }
                    subscription={ subscription }
                    errors={ paymentForm.errors }
                    submitPayment={ submitPayment }
                    paymentMethod={ paymentMethod }
                    thinking={ thinking }
                    grecaptchaApiKey={ grecaptchaApiKey }
                />
            </div>
        );
    }

    render() {
        const {
            email,
            thinking,
            invoices,
            onDownloadInvoice,
            clearDownloadError,
            errors
        } = this.props;

        const title = PageText.MY_SUBSCRIPTIONS;

        const subscriptionDetails = thinking === THINKING_TYPE_LOADING ? <LoadingMessage /> : this._showSubscriptionDetails();

        return (
            <div className="subscriptions">
                <h1 className="subscriptions__title">{ title }</h1>
                { AccountInformation(email) }
                { this._showPaymentInformation() }
                <div className="subscriptions__accounts">
                    { subscriptionDetails }
                </div>
                <BillingHistory
                    invoices={ invoices }
                    onDownloadInvoice={ onDownloadInvoice }
                    clearDownloadError={ clearDownloadError }
                    hasFileDownloadError={ !!errors[REDUX_ERROR_TYPES.FILE_DOWNLOAD] }
                />
            </div>
        );
    }
}

const AccountInformation = (email = "") => {
    return (
        <div className="subscriptions__account-information">
            <div className="subscriptions__account-information-title">Your Bloomberg account information</div>

            <div className="subscriptions__account-email">
                <span className="subscriptions__account-email-label">Email: </span>
                <span className="subscriptions__account-email-text">{ email }</span>
            </div>
        </div>
    );
};

export default Subscriptions;
